import { cliente } from './api'
import { obtenerTokenStorage } from './sessionStorage'

export default {
  ObtenerMotivosCancelacion() {
    return cliente.get('/credito/motivo_cancelacion', {
      headers: {
        Authorization: obtenerTokenStorage(),
      },
    })
  },
  CancelarSolicitud(folio, idMotivoCancelacion) {
    const request = {
      folioDigital: folio,
      idMotivo: idMotivoCancelacion,
    }
    const config = {
      headers: {
        Authorization: obtenerTokenStorage(),
      },
    }
    return cliente.post('/credito/motivo_cancelacion', request, config)
  },
}
